import { put, takeLatest } from "redux-saga/effects";
import {
  requestSuiteList,
  requestCreateSuite,
  requestUpdateSuite,
  requestDeleteSuite,
} from "../../../services/suite";
import {
  fetchSuiteListFailure,
  fetchSuiteListRequest,
  fetchSuiteListSuccess,
  createSuiteRequest,
  createSuiteSuccess,
  createSuiteFailure,
  updateSuiteRequest,
  updateSuiteSuccess,
  updateSuiteFailure,
  deleteSuiteRequest,
  deleteSuiteSuccess,
  deleteSuiteFailure,
} from "../../reducers/suite";

export function* watchSuiteSaga() {
  yield takeLatest(fetchSuiteListRequest, fetchSuiteList);
  yield takeLatest(createSuiteRequest, createSuite);
  yield takeLatest(updateSuiteRequest, updateSuite);
  yield takeLatest(deleteSuiteRequest, deleteSuite);
}

function* fetchSuiteList({ payload }) {
  try {
    const response = yield requestSuiteList(payload);
    // FetchInterceptor returns response.data, so response is already the API body { data, total, pageNumber, limit }
    yield put(fetchSuiteListSuccess(response));
  } catch (error) {
    yield put(fetchSuiteListFailure("Failed to get list of suites"));
  }
}

function* createSuite({ payload }) {
  try {
    const response = yield requestCreateSuite(payload);
    yield put(createSuiteSuccess(response?.data || response));
    yield put(fetchSuiteListRequest()); // refresh list after successful create
  } catch (error) {
    const data = error?.response?.data;
    const msg =
      (typeof data?.message === "string" && data.message) ||
      (typeof data?.error === "string" && data.error) ||
      error?.message ||
      "Failed to create suite";
    yield put(createSuiteFailure(msg));
  }
}

function* updateSuite({ payload }) {
  try {
    const response = yield requestUpdateSuite(payload);
    yield put(updateSuiteSuccess(response?.data || response));
    yield put(fetchSuiteListRequest()); // refresh list after successful update
  } catch (error) {
    const data = error?.response?.data;
    const msg =
      (typeof data?.message === "string" && data.message) ||
      (typeof data?.error === "string" && data.error) ||
      error?.message ||
      "Failed to update suite";
    yield put(updateSuiteFailure(msg));
  }
}

function* deleteSuite({ payload }) {
  try {
    yield requestDeleteSuite(payload);
    yield put(deleteSuiteSuccess(payload));
  } catch (error) {
    yield put(deleteSuiteFailure("Failed to delete suite"));
  }
}
